const config = window.WolfieFavourites || {};
const loggedIn = config.loggedIn === true;
const storageKey = `wolfieVoirFavourites:${config.customerKey || 'guest'}`;

const selectors = {
  button: '[data-favourite-button]',
  panel: '[data-favourites-panel]',
  list: '[data-favourites-list]',
  empty: '[data-favourites-empty]',
  count: '[data-favourites-count]',
};

function readFavourites() {
  try {
    return JSON.parse(localStorage.getItem(storageKey)) || [];
  } catch (error) {
    return [];
  }
}

function writeFavourites(items) {
  localStorage.setItem(storageKey, JSON.stringify(items));
}

function getButtonProduct(button) {
  return {
    id: button.dataset.productId,
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle,
    url: button.dataset.productUrl,
    image: button.dataset.productImage,
    price: button.dataset.productPrice,
  };
}

function escapeHTML(value = '') {
  return value.replace(/[&<>"']/g, (character) => {
    const replacements = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;',
    };

    return replacements[character];
  });
}

function isFavourited(productId) {
  return readFavourites().some((item) => item.id === productId);
}

function updateButtons() {
  document.querySelectorAll(selectors.button).forEach((button) => {
    const active = loggedIn && isFavourited(button.dataset.productId);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      `${active ? 'Remove' : 'Add'} ${button.dataset.productTitle} ${active ? 'from' : 'to'} favourites`
    );
  });
}

function removeFavourite(productId) {
  const nextItems = readFavourites().filter((item) => item.id !== productId);
  writeFavourites(nextItems);
  renderPanels();
  updateButtons();
}

function toggleFavourite(button) {
  if (!loggedIn) {
    window.location.href = config.loginUrl || '/account/login';
    return;
  }

  const product = getButtonProduct(button);
  const items = readFavourites();
  const existingIndex = items.findIndex((item) => item.id === product.id);

  if (existingIndex >= 0) {
    items.splice(existingIndex, 1);
  } else {
    items.unshift(product);
  }

  writeFavourites(items);
  renderPanels();
  updateButtons();
}

function renderPanels() {
  const items = readFavourites();

  document.querySelectorAll(selectors.panel).forEach((panel) => {
    const list = panel.querySelector(selectors.list);
    const empty = panel.querySelector(selectors.empty);
    const count = panel.querySelector(selectors.count);

    if (count) {
      count.textContent = items.length === 1 ? '1 item' : `${items.length} items`;
    }

    if (empty) {
      empty.hidden = items.length > 0;
    }

    if (!list) return;

    list.hidden = items.length === 0;
    list.innerHTML = items
      .map((item) => {
        const title = escapeHTML(item.title);
        const price = escapeHTML(item.price);
        const url = encodeURI(item.url);
        const image = item.image ? encodeURI(item.image) : '';

        return `
          <li class="wv-favourites-list__item">
            <a href="${url}" aria-label="${title}">
              ${
                image
                  ? `<img class="wv-favourites-list__image" src="${image}" alt="${title}" loading="lazy">`
                  : '<span class="wv-favourites-list__image" aria-hidden="true"></span>'
              }
            </a>
            <span>
              <a class="wv-favourites-list__title" href="${url}">${title}</a>
              <span class="wv-favourites-list__price">${price}</span>
            </span>
            <button class="wv-favourites-list__remove" type="button" data-favourite-remove="${item.id}" aria-label="Remove ${title} from favourites">
              <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </li>
        `;
      })
      .join('');
  });
}

function injectProductPageButton() {
  if (!config.currentProduct || document.querySelector('[data-product-favourite-row]')) return;

  const media = document.querySelector('.product-information__media');
  if (!media) return;
  const firstMedia = media.querySelector('.product-media-container, .product-media');
  if (!firstMedia) return;

  const row = document.createElement('div');
  row.className = 'wv-product-favourite-row';
  row.dataset.productFavouriteRow = 'true';

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'wv-favourite-button';
  button.dataset.favouriteButton = 'true';
  button.dataset.productId = config.currentProduct.id;
  button.dataset.productHandle = config.currentProduct.handle;
  button.dataset.productTitle = config.currentProduct.title;
  button.dataset.productUrl = config.currentProduct.url;
  button.dataset.productImage = config.currentProduct.image;
  button.dataset.productPrice = config.currentProduct.price;
  button.setAttribute('aria-pressed', 'false');
  button.setAttribute('aria-label', `Add ${config.currentProduct.title} to favourites`);
  button.innerHTML = `
    <span class="wv-favourite-button__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false">
        <path d="M12 20.4c-.3-.28-.86-.76-1.66-1.43-4.74-3.96-7.1-6.88-7.1-9.55 0-2.61 1.78-4.42 4.12-4.42 1.48 0 2.78.78 3.56 2.02L12 8.74l1.08-1.72C13.86 5.78 15.16 5 16.64 5c2.34 0 4.12 1.81 4.12 4.42 0 2.67-2.36 5.59-7.1 9.55-.8.67-1.36 1.15-1.66 1.43Z" />
      </svg>
    </span>
  `;

  row.append(button);
  firstMedia.prepend(row);
}

function injectProductSummary() {
  if (!config.currentProduct?.description) return;

  const buyButtons = document.querySelector('.product-details .buy-buttons-block');
  if (!buyButtons) return;

  const summary = document.querySelector('[data-product-summary]') || document.createElement('p');
  summary.className = 'wv-product-summary';
  summary.dataset.productSummary = 'true';
  summary.textContent = config.currentProduct.description;

  if (window.matchMedia('(max-width: 749px)').matches) {
    buyButtons.insertAdjacentElement('beforebegin', summary);
  } else {
    buyButtons.insertAdjacentElement('afterend', summary);
  }
}

function injectProductBreadcrumb() {
  if (!config.currentProduct?.breadcrumb?.length || document.querySelector('[data-product-breadcrumb]')) return;

  const details = document.querySelector('.product-details .group-block-content');
  if (!details) return;

  const breadcrumbItems = config.currentProduct.breadcrumb;
  if (!breadcrumbItems.length) return;

  const breadcrumb = document.createElement('nav');
  breadcrumb.className = 'wv-product-breadcrumb';
  breadcrumb.dataset.productBreadcrumb = 'true';
  breadcrumb.setAttribute('aria-label', 'Product path');

  breadcrumbItems.forEach((item, index) => {
    if (index > 0) {
      const separator = document.createElement('span');
      separator.className = 'wv-product-breadcrumb__separator';
      separator.textContent = '·';
      breadcrumb.append(separator);
    }

    const isLastItem = index === breadcrumbItems.length - 1;
    const element = document.createElement(isLastItem ? 'span' : 'a');
    element.className = 'wv-product-breadcrumb__item';
    element.textContent = item.label;

    if (!isLastItem && item.url) {
      element.href = item.url;
    }

    breadcrumb.append(element);
  });

  details.prepend(breadcrumb);
}

function syncSwatchLabels() {
  document.querySelectorAll('.product-details .variant-option--swatches').forEach((fieldset) => {
    const selectedLabel =
      fieldset.querySelector('.variant-option__button-label:has(input:checked)') ||
      fieldset.querySelector('.variant-option__button-label');
    const value = fieldset.querySelector('.variant-option__swatch-value')?.textContent?.trim();

    if (!selectedLabel || !value) return;

    let inlineValue = fieldset.querySelector('[data-inline-swatch-value]');
    if (!inlineValue) {
      inlineValue = document.createElement('span');
      inlineValue.className = 'wv-inline-swatch-value';
      inlineValue.dataset.inlineSwatchValue = 'true';
      selectedLabel.insertAdjacentElement('afterend', inlineValue);
    }

    inlineValue.textContent = value;
    fieldset.classList.add('wv-swatch-inline-ready');
  });
}

document.addEventListener('click', (event) => {
  const favouriteButton = event.target.closest(selectors.button);
  if (favouriteButton) {
    event.preventDefault();
    event.stopPropagation();
    toggleFavourite(favouriteButton);
    return;
  }

  const removeButton = event.target.closest('[data-favourite-remove]');
  if (removeButton) {
    removeFavourite(removeButton.dataset.favouriteRemove);
  }
});

document.addEventListener('change', (event) => {
  if (event.target.closest('.product-details .variant-option--swatches')) {
    window.requestAnimationFrame(syncSwatchLabels);
  }
});

window.addEventListener('resize', injectProductSummary);

document.addEventListener('DOMContentLoaded', () => {
  injectProductBreadcrumb();
  injectProductPageButton();
  injectProductSummary();
  syncSwatchLabels();
  renderPanels();
  updateButtons();
});

document.addEventListener('shopify:section:load', () => {
  injectProductBreadcrumb();
  injectProductPageButton();
  injectProductSummary();
  syncSwatchLabels();
  renderPanels();
  updateButtons();
});
